import { render, staticRenderFns } from "./rptsales.vue?vue&type=template&id=2222f7fd&scoped=true"
import script from "./rptsales.vue?vue&type=script&lang=js"
export * from "./rptsales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222f7fd",
  null
  
)

export default component.exports